// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1KkrA","checkboxCol":"Table_checkboxCol__3fWg8","emailCol":"Table_emailCol__JASuV","actionCol":"Table_actionCol__2GHz4"};